/**
 * Static DeltaBest API shape for `convertDeltaBestToChartData` when user is not premium.
 * Aligns loosely with custom pricing placeholder supplier names/IDs.
 */
const d = (
  supplier,
  enerexId,
  rank,
  curr
) => ({
  Supplier: supplier,
  EnerexSupplierIdentifier: enerexId,
  Rank: rank,
  Deltas: [
    {
      CurrPrice: curr,
      BestPrice: Math.round(curr * 0.98 * 100000) / 100000,
      WorstPrice: Math.round(curr * 1.05 * 100000) / 100000,
      NextBetterPrice: Math.round(curr * 0.99 * 100000) / 100000,
      NextWorsePrice: Math.round(curr * 1.02 * 100000) / 100000,
    },
  ],
});

const A = "38e36fc8-0c9a-4774-9632-555e6c28bb37";
const B = "9c5337fd-2030-4510-bd57-c736bfdd8e35";
const C = "64304cdd-0011-4a7e-b0e5-147c9ff78675";

const STATIC_RANKINGS_DELTA_BEST_RAW = [
  {
    Date: "01/23/26",
    Suppliers: [
      d("Supplier A", A, 1, 0.071),
      d("Supplier B", B, 2, 0.065),
      d("Supplier C", C, 3, 0.072),
    ],
  },
  {
    Date: "02/05/26",
    Suppliers: [
      d("Supplier B", B, 1, 0.064),
      d("Supplier A", A, 2, 0.069),
      d("Supplier C", C, 3, 0.073),
    ],
  },
  {
    Date: "02/19/26",
    Suppliers: [
      d("Supplier A", A, 1, 0.067),
      d("Supplier C", C, 2, 0.07),
      d("Supplier B", B, 3, 0.066),
    ],
  },
  {
    Date: "03/03/26",
    Suppliers: [
      d("Supplier C", C, 1, 0.068),
      d("Supplier B", B, 2, 0.067),
      d("Supplier A", A, 3, 0.07),
    ],
  },
  {
    Date: "03/17/26",
    Suppliers: [
      d("Supplier B", B, 1, 0.063),
      d("Supplier A", A, 2, 0.068),
      d("Supplier C", C, 3, 0.071),
    ],
  },
  {
    Date: "03/31/26",
    Suppliers: [
      d("Supplier A", A, 1, 0.066),
      d("Supplier B", B, 2, 0.065),
      d("Supplier C", C, 3, 0.069),
    ],
  },
];

export { STATIC_RANKINGS_DELTA_BEST_RAW };
